import { useEffect } from 'react'
import { useLocation } from '@remix-run/react'

import useApp from '~/hooks/useApp'
import useRouteContext from '~/hooks/useRouteContext'
import useAnalytics, { AnalyticsEvents } from '~/hooks/useAnalytics'

declare global {
    interface Window {
        dataLayer: any[]
    }
}

const Head = () => {
    const {
        NODE_ENV,
        GTM_TRACKING_ID
    } = useRouteContext()
    
    const app = useApp()

    return (
        NODE_ENV !== 'development' && GTM_TRACKING_ID ? (
            <script
                suppressHydrationWarning={true}
                dangerouslySetInnerHTML={{
                    __html: `
                        (function (_windoww, _document, _script, _layer, _trackingId) {
                            _windoww[_layer] = _windoww[_layer] || [];
                            _windoww[_layer].push({ event: 'gtm.init', app_type: '${app.id}' });
                            _windoww[_layer].push({ event: 'gtm.js', 'gtm.start': new Date().getTime() });

                            var firstScript = _document.getElementsByTagName(_script)[0];
                            var newScript = _document.createElement(_script), dl = _layer != 'dataLayer' ? '&l=' + _layer : '';

                            newScript.async = true;
                            newScript.src = 'https://www.googletagmanager.com/gtm.js?id=' + _trackingId + dl;
                            
                            firstScript.parentNode.insertBefore(newScript, firstScript);
                        })(window, document, 'script', 'dataLayer', '${GTM_TRACKING_ID}');
                    `
                }}
            />
        ) : (
            null
        )
    )
}

const Body = () => {
    const {
        NODE_ENV,
        GTM_TRACKING_ID
    } = useRouteContext()

    const location = useLocation()
    const { event: analyticsEvent } = useAnalytics()

    useEffect(() => {
        if (NODE_ENV !== 'development' && GTM_TRACKING_ID) {
            analyticsEvent(AnalyticsEvents.PageView, {
                page_title: document.title,
                page_location: window.location.href,
                page_path: location.pathname
            })
        }
    }, [
        GTM_TRACKING_ID,
        NODE_ENV,
        analyticsEvent,
        location
    ])

    return (
        NODE_ENV !== 'development' && GTM_TRACKING_ID ? (
            <noscript>
                <iframe
                    title={'Google Tag Manager'}
                    src={`https://www.googletagmanager.com/ns.html?id=${GTM_TRACKING_ID}`}
                    height={'0'}
                    width={'0'}
                    style={{
                        display: 'none',
                        visibility: 'hidden'
                    }}
                />
            </noscript>
        ) : (
            null
        )
    )
}

const Analytics = {
    Head,
    Body
}

export default Analytics